
import VueHorizontalList from 'vue-horizontal-list'
import cartMixin from '~/mixins/cartMixin'
import commercialOperationPrice from '~/mixins/commercialOperationPrice'
import ProductStockStatus from './ProductStockStatus.vue'

export default {
  components: {
    VueHorizontalList,
    ProductStockStatus,
  },
  mixins: [cartMixin, commercialOperationPrice],

  props: {
    variants: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      hoveredVariant: null,
    }
  },
  computed: {
    hoveredOperationPrice() {
      return this.hoveredVariant
        ? this.variantOperationPrice(this.hoveredVariant)
        : null
    },
  },
  methods: {
    variantOperationPrice(variant) {
      return this.operationPriceOf(
        { ...variant.product, variant },
        { beforeTax: this.$store.getters.is_pro }
      )
    },
    navigateToProduct(variant) {
      this.trackOperationBadgeProductClick(
        variant.product,
        this.variantOperationPrice(variant)
      )
      this.$router.push(
        this.localePath({
          name: 'produit-slug',
          params: { slug: variant.product.slug },
          query: { variant: variant.id, fv: true },
        })
      )
    },
    addHoveredVariantToCart() {
      if (this.addingProductToCart) return
      const variant = this.hoveredVariant
      this.addToCart({ ...variant.product, variant }, variant)
    },
  },
}
